__turbopack_context__.v({
  "brandName": "Gj9EUW_brandName",
  "itemCheckbox": "Gj9EUW_itemCheckbox",
  "notReturnableLabel": "Gj9EUW_notReturnableLabel",
  "priceColumn": "Gj9EUW_priceColumn",
  "productBlock": "Gj9EUW_productBlock",
  "productDetails": "Gj9EUW_productDetails",
  "productImageWrapper": "Gj9EUW_productImageWrapper",
  "productMeta": "Gj9EUW_productMeta",
  "productName": "Gj9EUW_productName",
  "productRow": "Gj9EUW_productRow",
  "productRowDisabled": "Gj9EUW_productRowDisabled",
  "quantityControls": "Gj9EUW_quantityControls",
  "quantityIconButton": "Gj9EUW_quantityIconButton",
  "quantityValue": "Gj9EUW_quantityValue",
  "selectColumn": "Gj9EUW_selectColumn",
});
